exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ad-details[data-v-3ba197fb]{margin-top:6px;font-size:.78rem}.ad-summary[data-v-3ba197fb]{cursor:pointer;color:#510087;font-weight:600;outline:none}.ad-body[data-v-3ba197fb]{margin-top:8px}.ad-subtitle[data-v-3ba197fb]{font-weight:600;margin:8px 0 4px;color:#4a4a4a}.ad-table[data-v-3ba197fb]{width:100%;border-collapse:collapse;margin-bottom:8px}.ad-table td[data-v-3ba197fb],.ad-table th[data-v-3ba197fb]{text-align:left;padding:4px 8px;border-bottom:1px solid #eee}.ad-table th[data-v-3ba197fb]{color:#7a7a7a;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ba197fb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/components/variables-prioritarias/AnalysisDisclosure.vue
// module id = 2169
// module chunks = 2